import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
import { DropdownModule } from 'primeng/dropdown';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipsModule } from 'primeng/chips';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DividerModule } from 'primeng/divider';
import { TimelineModule } from 'primeng/timeline';
import { CardModule } from 'primeng/card';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';
import { PanelModule } from 'primeng/panel';
import { CalendarModule } from 'primeng/calendar';
import { AccordionModule } from 'primeng/accordion';
import { InputMaskModule } from 'primeng/inputmask';
import { PaginatorModule } from 'primeng/paginator';
import { InplaceModule } from 'primeng/inplace';
import { FileUploadModule } from 'primeng/fileupload';
import { TreeModule } from 'primeng/tree';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { ListboxModule } from 'primeng/listbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { CommonModule } from '@angular/common';
import { InputNumberModule } from 'primeng/inputnumber';
import { KnobModule } from 'primeng/knob';
import { ProgressBarModule } from 'primeng/progressbar';
import { ChartModule } from 'primeng/chart';
import { PickListModule } from 'primeng/picklist';
import { MatIconModule } from '@angular/material/icon';
import { TabViewModule } from 'primeng/tabview';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { ConfirmationService } from 'primeng/api';
import { FieldsetModule } from 'primeng/fieldset';

class PrimengLibraryModule {
}
PrimengLibraryModule.ɵfac = function PrimengLibraryModule_Factory(t) { return new (t || PrimengLibraryModule)(); };
PrimengLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: PrimengLibraryModule });
PrimengLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [ConfirmationService], imports: [[
            CommonModule,
            DropdownModule,
            DividerModule,
            ButtonModule,
            ChipsModule,
            CheckboxModule,
            ToggleButtonModule,
            InputSwitchModule,
            RadioButtonModule,
            OverlayPanelModule,
            TimelineModule,
            CardModule,
            InputMaskModule,
            PaginatorModule,
            DynamicDialogModule,
            InplaceModule,
            TooltipModule,
            TableModule,
            FileUploadModule,
            PanelModule,
            CalendarModule,
            AccordionModule,
            TreeModule,
            ConfirmDialogModule,
            DialogModule,
            InputNumberModule,
            ListboxModule,
            MultiSelectModule,
            KnobModule,
            ProgressBarModule,
            ChartModule,
            TabViewModule,
            PickListModule,
            AutoCompleteModule,
            InputTextareaModule,
            TieredMenuModule,
            TriStateCheckboxModule,
            FieldsetModule
        ], CommonModule,
        DropdownModule,
        DividerModule,
        ButtonModule,
        ChipsModule,
        CheckboxModule,
        ToggleButtonModule,
        InputSwitchModule,
        RadioButtonModule,
        OverlayPanelModule,
        TimelineModule,
        CardModule,
        InputMaskModule,
        PaginatorModule,
        DynamicDialogModule,
        InplaceModule,
        TooltipModule,
        TableModule,
        FileUploadModule,
        PanelModule,
        CalendarModule,
        AccordionModule,
        TreeModule,
        ConfirmDialogModule,
        DialogModule,
        InputNumberModule,
        ListboxModule,
        MultiSelectModule,
        KnobModule,
        ProgressBarModule,
        ChartModule,
        PickListModule,
        MatIconModule,
        TabViewModule,
        AutoCompleteModule,
        InputTextareaModule,
        TieredMenuModule,
        TriStateCheckboxModule,
        FieldsetModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PrimengLibraryModule, { imports: [CommonModule,
        DropdownModule,
        DividerModule,
        ButtonModule,
        ChipsModule,
        CheckboxModule,
        ToggleButtonModule,
        InputSwitchModule,
        RadioButtonModule,
        OverlayPanelModule,
        TimelineModule,
        CardModule,
        InputMaskModule,
        PaginatorModule,
        DynamicDialogModule,
        InplaceModule,
        TooltipModule,
        TableModule,
        FileUploadModule,
        PanelModule,
        CalendarModule,
        AccordionModule,
        TreeModule,
        ConfirmDialogModule,
        DialogModule,
        InputNumberModule,
        ListboxModule,
        MultiSelectModule,
        KnobModule,
        ProgressBarModule,
        ChartModule,
        TabViewModule,
        PickListModule,
        AutoCompleteModule,
        InputTextareaModule,
        TieredMenuModule,
        TriStateCheckboxModule,
        FieldsetModule], exports: [CommonModule,
        DropdownModule,
        DividerModule,
        ButtonModule,
        ChipsModule,
        CheckboxModule,
        ToggleButtonModule,
        InputSwitchModule,
        RadioButtonModule,
        OverlayPanelModule,
        TimelineModule,
        CardModule,
        InputMaskModule,
        PaginatorModule,
        DynamicDialogModule,
        InplaceModule,
        TooltipModule,
        TableModule,
        FileUploadModule,
        PanelModule,
        CalendarModule,
        AccordionModule,
        TreeModule,
        ConfirmDialogModule,
        DialogModule,
        InputNumberModule,
        ListboxModule,
        MultiSelectModule,
        KnobModule,
        ProgressBarModule,
        ChartModule,
        PickListModule,
        MatIconModule,
        TabViewModule,
        AutoCompleteModule,
        InputTextareaModule,
        TieredMenuModule,
        TriStateCheckboxModule,
        FieldsetModule] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PrimengLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [
                    CommonModule,
                    DropdownModule,
                    DividerModule,
                    ButtonModule,
                    ChipsModule,
                    CheckboxModule,
                    ToggleButtonModule,
                    InputSwitchModule,
                    RadioButtonModule,
                    OverlayPanelModule,
                    TimelineModule,
                    CardModule,
                    InputMaskModule,
                    PaginatorModule,
                    DynamicDialogModule,
                    InplaceModule,
                    TooltipModule,
                    TableModule,
                    FileUploadModule,
                    PanelModule,
                    CalendarModule,
                    AccordionModule,
                    TreeModule,
                    ConfirmDialogModule,
                    DialogModule,
                    InputNumberModule,
                    ListboxModule,
                    MultiSelectModule,
                    KnobModule,
                    ProgressBarModule,
                    ChartModule,
                    TabViewModule,
                    PickListModule,
                    AutoCompleteModule,
                    InputTextareaModule,
                    TieredMenuModule,
                    TriStateCheckboxModule,
                    FieldsetModule
                ],
                exports: [
                    CommonModule,
                    DropdownModule,
                    DividerModule,
                    ButtonModule,
                    ChipsModule,
                    CheckboxModule,
                    ToggleButtonModule,
                    InputSwitchModule,
                    RadioButtonModule,
                    OverlayPanelModule,
                    TimelineModule,
                    CardModule,
                    InputMaskModule,
                    PaginatorModule,
                    DynamicDialogModule,
                    InplaceModule,
                    TooltipModule,
                    TableModule,
                    FileUploadModule,
                    PanelModule,
                    CalendarModule,
                    AccordionModule,
                    TreeModule,
                    ConfirmDialogModule,
                    DialogModule,
                    InputNumberModule,
                    ListboxModule,
                    MultiSelectModule,
                    KnobModule,
                    ProgressBarModule,
                    ChartModule,
                    PickListModule,
                    MatIconModule,
                    TabViewModule,
                    AutoCompleteModule,
                    InputTextareaModule,
                    TieredMenuModule,
                    TriStateCheckboxModule,
                    FieldsetModule
                ],
                providers: [ConfirmationService]
            }]
    }], null, null); })();

/*
 * Public API Surface of primeng-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PrimengLibraryModule };
//# sourceMappingURL=primeng-library.js.map
